module.exports = __webpack_public_path__ + "static/media/picture_rade.00d0cfa4.jpg";